export default {
  title: "Soporte",
  rules: {
    note: "Antes de enviar una solicitud, por favor revise las reglas:",
    rule_1: "1. Primero, consulte la sección de {faq} (FAQ) — es posible que la respuesta ya esté allí.",
    rule_2: "2. En caso de problemas con el pago, asegúrese de incluir los detalles de la transacción (fecha, importe, método de pago, capturas de pantalla).",
    rule_3: "3. Si tiene problemas para descargar archivos, asegúrese de indicar los enlaces a esos archivos.",
    rule_4: "4. Para cuestiones de derechos de autor o cualquier otro archivo que infrinja las reglas, escriba a: {email}",
    rule_5: "5. Para cooperación, programas de afiliados, publicidad y otras propuestas comerciales, escriba a: {email}",
    rule_6: "6. La respuesta puede tardar de 12 horas a 2 días hábiles, según la complejidad de la solicitud y la carga del soporte.",
    rules: "reglas",
    faq: "preguntas frecuentes"
  },
  messages: {
    note: "*Se muestran los últimos {count} mensajes",
    you: "Usted",
    support: "Soporte",
    autoanswer_subject_is_over: "La conversación se ha cerrado porque su problema ha sido resuelto.\nGracias por ponerse en contacto con el servicio de soporte."
  },
  inputs: {
    message: {
      placeholder: "Escriba su pregunta"
    },
    attachments: {
      btn: "{text} {formats}",
      attach_file: "Adjuntar archivo",
      attached_files: "Archivos adjuntos:"
    }
  },
  errors: {
    generic: "Error",
    invalid_file_type: "Formato de archivo no compatible.",
    max_file_size_limit: "El archivo es demasiado grande. Elija un archivo más pequeño.",
    filename_too_long: "El nombre del archivo es demasiado largo",
    filename_invalid_chars: "El nombre del archivo contiene caracteres no válidos"
  },
  btn: {
    send: "Enviar"
  }
};
